import api from '../../../services/api';
import { FactoryDto, FactoryInput, normalizeFactories, normalizeFactory } from '../../../dto/factory';

export async function fetchFactories(): Promise<FactoryDto[]> {
  const response = await api.get('/factories');
  return normalizeFactories(response.data);
}

function requireFactory(raw: unknown): FactoryDto {
  const factory = normalizeFactory(raw);
  if (!factory) {
    throw new Error('Server returned an invalid factory payload');
  }
  return factory;
}

export async function createFactoryRecord(payload: FactoryInput): Promise<FactoryDto> {
  const response = await api.post('/factories', payload);
  return requireFactory(response.data);
}

export async function updateFactoryRecord(id: string, payload: FactoryInput): Promise<FactoryDto> {
  const response = await api.put(`/factories/${id}`, payload);
  return requireFactory(response.data);
}

export async function deleteFactoryRecord(id: string): Promise<void> {
  await api.delete(`/factories/${id}`);
}
